export default __webpack_public_path__ + "static/media/profile-icon.6992329f.svg";